















import { Component, Prop, Vue } from "vue-property-decorator";
import { IArticleCard } from "@/store/interfaces/article";
import ellipsizeTextBox from "@/services/textElip";
import { BASE_URL } from "@/api/parts/createEditor";

@Component({
  name: "ArticleCard"
})
export default class ArticleCard extends Vue {
  @Prop({ default: null })
  article: IArticleCard;

  elepsize: boolean = false;

  mounted() {
    // ellipsizeTextBox(this.$refs["title"]);
  }

  createImgLink(name) {
    if (name.search(/http/g) !== -1) {
      return name;
    }
    return `${BASE_URL}/images/${name.split(".")[0]}-sm.${name.split(".")[1]}`;
  }
}
